export interface SiteAvailability {
  stablecoin: boolean;
}

export const unavailableSiteAvailability: SiteAvailability = {
  stablecoin: false,
};

/**
 * CloudFront uses ISO 3166-1 alpha-2 country codes. Missing or malformed
 * headers are treated as unavailable so the restriction fails closed.
 */
export function siteAvailabilityForCountryHeader(countryHeader: string | null): SiteAvailability {
  const countryCode = countryHeader?.trim().toUpperCase();
  const hasValidCountryCode = countryCode != null && /^[A-Z]{2}$/.test(countryCode);

  return {
    stablecoin: hasValidCountryCode && countryCode !== 'GB',
  };
}

export function parseSiteAvailability(value: unknown): SiteAvailability {
  if (
    typeof value === 'object' &&
    value !== null &&
    'stablecoin' in value &&
    value.stablecoin === true
  ) {
    return { stablecoin: true };
  }

  return unavailableSiteAvailability;
}
